function initWanqiProductForms() {
  var roots = document.querySelectorAll('[data-product-root]');
  roots.forEach(function (root) {
    var form = root.querySelector('form[action="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (event) {
        var variantInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('[name="quantity"]');
        if (!variantInput || !variantInput.value) return;

        event.preventDefault();

        var submit = form.querySelector('button[type="submit"]');
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Adding...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantInput.value),
            quantity: Number(quantityInput && quantityInput.value ? quantityInput.value : 1)
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            form.submit();
          });
      });
    }

    var jsonEl = root.querySelector('[data-product-json]');
    var variantInput = root.querySelector('[data-variant-id]');
    var optionEls = root.querySelectorAll('[data-product-option]');
    if (!jsonEl || !variantInput || !optionEls.length) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (error) {
      return;
    }

    function selectedOptions() {
      return Array.prototype.map.call(optionEls, function (select) {
        return select.value;
      });
    }

    function updateVariant() {
      var selected = selectedOptions();
      var variant = product.variants.find(function (item) {
        return item.options.every(function (value, index) {
          return value === selected[index];
        });
      });
      if (!variant) return;
      variantInput.value = variant.id;
      var submit = root.querySelector('button[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to Cart' : 'Currently unavailable';
      }
    }

    optionEls.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWanqiProductForms);
} else {
  initWanqiProductForms();
}
